import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuth } from '@/hooks/useAuth';

export const EVENT_INTELLIGENCE_ACCESS_QUERY_KEY = 'event-intelligence-access';

export interface EventIntelligenceAccess {
  enabled: boolean;
  isLoading: boolean;
}

// The `event-intelligence` PostHog flag is read by the API, not by posthog-js: the server is the
// gate that 404s every event route, so asking it keeps the UI and API in agreement, and the
// Development-only MERIDIAN_FEATURE_FLAG_OVERRIDES reaches both. Fails closed on any error.
export function useEventIntelligenceAccess(): EventIntelligenceAccess {
  const { user, isLoading: authLoading } = useAuth();
  const query = useQuery({
    queryKey: [EVENT_INTELLIGENCE_ACCESS_QUERY_KEY, user?.id],
    queryFn: async () => (await api.get<{ enabled: boolean }>('/event-intelligence/access')).data.enabled === true,
    enabled: !!user,
    staleTime: 5 * 60_000,
    retry: false,
  });

  return {
    enabled: query.data === true,
    isLoading: authLoading || (!!user && query.isPending),
  };
}
